const setError = (state, error) => {
  state.error = error;
};

const setLoading = (state, isLoading) => {
  state.loading = isLoading;
};

const setRecords = (state, records) => {
  if (!records) {
    state.records = [];
    return;
  }

  state.records = records.map(record => ({
    ...record,
    // cull null values (issue discovered during implementation)
    services: record.services ? record.services.filter(service => service) : [],
  }));
};

export default {
  setError,
  setLoading,
  setRecords,
};
